<template>
    <a-modal
        :width="'50%'"
        v-model="updateBasic"
        :title="$t('org.editBasicInfo')"
        :maskClosable="maskClosable"
        @ok="handleOk">

        <div style="padding:20px;">
            <a-card>
                <a-form :form="basicForm">
                    <a-form-item :label="org.level == 2 ? $t('org.integrator') : $t('org.orgName')" v-bind="formItemLayout">
                        <a-input size="small" v-model="org.name" v-decorator="['orgName',{ rules: [{ required: true,  message: org.level == 2 ? $t('org.validateTip.integratorRequired') : $t('org.validateTip.orgNameRequired') },{ max: 30,  message: org.level == 2 ? $t('org.validateTip.integratorRule') : $t('org.validateTip.orgNameRule')},{ validator: hasSpecialChar}, { validator: queryHasSameOrgName}], validateTrigger: 'blur' }]"></a-input>
                    </a-form-item>

                    <a-form-item :label="org.level == 2 ? $t('org.integratorDescription') : $t('org.orgDescription')" v-bind="formItemLayout">
                        <a-textarea size="small"   v-model="org.remark" v-decorator="['orgDescription',{ rules: [{ required: true, message: org.level == 2 ? $t('org.validateTip.integratorDescriptionRequired') : $t('org.validateTip.orgDescriptionRequired')   },
                        { max: 200, message: org.level == 2 ? $t('org.validateTip.integratorDescriptionRule') : $t('org.validateTip.orgDescriptionRule')}] }]"></a-textarea>
                    </a-form-item>

                    <!-- <a-form-item :label="$t('org.parentName')" v-bind="formItemLayout" v-if="org.parentName">
                        <a-input size="small" v-model="org.parentName" disabled></a-input>
                    </a-form-item> -->

                    <a-form-item :label="$t('org.linkMan')" v-bind="formItemLayout">
                        <a-input size="small" v-model="org.contacts" v-decorator="['orgContacts',{ rules: [{ max: 20, message: $t('org.validateTip.linkManRule')}, { validator: hasSpecialChar}] }]"></a-input>
                    </a-form-item>

                    <a-form-item :label="$t('org.phone')" v-bind="formItemLayout">
                        <a-input v-model="org.contactsPhone" size="small"  v-decorator="['orgContactsPhone',{ rules: [{ pattern: /^1[34578]\d{9}$/, message: $t('org.validateTip.phoneRule')}] }]"></a-input>
                    </a-form-item>

                    <a-form-item :label="$t('org.email')" v-bind="formItemLayout">
                        <a-input v-model="org.email" size="small"  v-decorator="['orgEmail',{ rules: [{ type: 'email', message: $t('org.validateTip.emailRule')}] }]"></a-input>
                    </a-form-item>

                    <a-form-item :label="$t('org.scenes')" v-bind="formItemLayout">
                        <a-select v-model="org.scenes" size="small" mode="multiple">
                            <a-select-option v-for="item in scenesOption" :value="item.id">{{item.title}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-form>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    import {hasSpecialChar} from '../../utils/formFunctions'
    export default {
        name: 'ZUpdateOrgBasic',
        data() {
            return {
                // 是否处在修改用户短信数量
                onEditMessageNum: false,
                // 用户剩余短信数量
                userMessageNum: 0,
                // 给用户增加的短信数量
                addUserMessageNum: 0,
                maskClosable: false,
                updateBasic: false,
                basicForm: null,
                org: {},
                formItemLayout: {
                    labelCol: {
                        xs: { span: 18 },
                        sm: { span: 6 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 },
                    }
                },
                scenesOption:[],
            }
        },
        mounted() {
            this.getScenes();
        },
        methods: {
            hasSpecialChar,
            // 查询机构名称是否被占用
            queryHasSameOrgName (rule, value, callback) {
                let params = {parentLink: this.link, name: value}
                // console.log(params)
                this.$http.post(config.api.check_has_same_org_name, params).then((res) => {
                    // console.log(res)
                    if (res.code === 0) {
                        callback()
                    } else {
                        callback(res.desc)
                    }
                })
            },
            // 修改用户剩余的短信数量
            editMessageNum () {
                // console.log(oldNum)
                this.onEditMessageNum = true
            },
            editMessageNumComplete () {
                //发送请求修改
                this.$http.put(`/api/org/v1.0/sms/charge/${this.org.id}/${this.addUserMessageNum}`).then((res) => {
                    console.log(res)
                    if (res.code === 0) {
                        this.userMessageNum = res.result.smsNumRemain
                    }
                    // 成功后执行
                    this.onEditMessageNum = false
                }).catch((err) => {
                    if (err) {
                        // this.$notification.open()
                        console.log(err)
                    }
                })
            },
            handleOk(){
                this.basicForm.validateFieldsAndScroll((err, values) => {
                    if (!err) {
                        let org = {}
                        org.id = this.org.id
                        org.name = this.org.name
                        org.remark = this.org.remark
                        org.contacts = this.org.contacts
                        org.contactsPhone = this.org.contactsPhone
                        org.email = this.org.email
                        // org.smsNumRemain = this.userMessageNum
                        let scenes = this.org.scenes;
                        if(scenes && scenes.length > 0){
                            org.scenes = scenes.length > 1 ? scenes.join(",") : scenes[0]
                        }else {
                            org.scenes = null
                        }
                        this.$http.put(config.api.org_url,org).then((response) => {
                            if(response.code == 0){
                                this.updateBasic = false
                                // this.$message.success('修改成功')
                                this.$notification.success({
                                  message: this.$t('global.commitSuccess'),
                                })
                                this.$emit("updateSuccess",this.org.id)
                            } else {
                                this.$message.error(response.desc)
                            }
                        })
                    }
                })
            },
            showModel(org){
                this.org = org
                if(org.scenes)
                    this.org.scenes = org.scenes.split(",")
                this.updateBasic = true
                this.userMessageNum = this.org.smsNumRemain
                this.basicForm = this.$form.createForm(this)
                // let _this = this
                // setTimeout(() => {
                //     _this.basicForm.setFieldsValue({
                //         orgName: org.name
                //     });
                //     _this.basicForm.setFieldsValue({
                //         orgDescription: org.remark
                //     });
                // },200);
                this.$nextTick().then(() => {
                    this.basicForm.setFieldsValue({
                        orgName: org.name,
                        orgDescription: org.remark,
                        orgContacts: org.contacts,
                        orgContactsPhone: org.contactsPhone,
                        orgEmail: org.email
                    })
                })
            },
            getScenes () {
                //发送请求修改
                this.$http.get(`/api/org/v1.0/scenes`).then((res) => {
                    console.log(res)
                    if (res.code === 0) {
                        this.scenesOption = res.result
                    }
                }).catch((err) => {
                    if (err) {
                        console.log(err)
                    }
                })
            }
        }
    }
</script>
